import { z } from "zod";

export const PostCustomShippingRateRequestBodySchema = z.object({
  shopId: z.string(),
  performingUserEmail: z.string().optional(),
  rateDescription: z.string(),
});
export type PostCustomShippingRateRequestBodyType = z.infer<
  typeof PostCustomShippingRateRequestBodySchema
>;

export const PostCustomShippingRateRequestPathParamSchema = z.object({
  experienceId: z.string().uuid(),
});
export type PostCustomShippingRateRequestPathParamType = z.infer<
  typeof PostCustomShippingRateRequestPathParamSchema
>;
